import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { queryClient } from "./lib/queryClient";
import { Landing } from "./pages/Landing";
import { AcceptInvite } from "./pages/auth/AcceptInvite";
import { Login } from "./pages/auth/Login";
import { Pending } from "./pages/auth/Pending";
import { Register } from "./pages/auth/Register";
import { Verified } from "./pages/auth/Verified";
import { DashboardLayout } from "./pages/dashboard/DashboardLayout";
import { RequireAuth } from "./pages/dashboard/RequireAuth";
import { Advertisers } from "./pages/dashboard/sections/Advertisers";
import { Downloads } from "./pages/dashboard/sections/Downloads";
import { Media } from "./pages/dashboard/sections/Media";
import { Playlists } from "./pages/dashboard/sections/Playlists";
import { Reports } from "./pages/dashboard/sections/Reports";
import { ScreenGroups } from "./pages/dashboard/sections/ScreenGroups";
import { Screens } from "./pages/dashboard/sections/Screens";
import { Settings } from "./pages/dashboard/sections/Settings";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/pending" element={<Pending />} />
          <Route path="/verified" element={<Verified />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <DashboardLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="screens" replace />} />
            <Route path="screens" element={<Screens />} />
            <Route path="groups" element={<ScreenGroups />} />
            <Route path="media" element={<Media />} />
            <Route path="advertisers" element={<Advertisers />} />
            <Route path="playlists" element={<Playlists />} />
            <Route path="reports" element={<Reports />} />
            <Route path="downloads" element={<Downloads />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          {/* /player is still served by FastAPI directly — the Pi kiosk runs
              against legacy static HTML and stays untouched. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
